import { useHotkey as useTanstackHotkey } from "@tanstack/react-hotkeys";
import { trackKeyboardShortcutPressed } from "@/modules/keyboard-shortcuts/metrics";
import type { HotkeyCallback, RegisterableHotkey, UseHotkeyOptions } from "@tanstack/react-hotkeys";

export type { HotkeyOptions, UseHotkeyOptions } from "@tanstack/react-hotkeys";

export const useHotkey = (
  hotkey: RegisterableHotkey,
  callback: HotkeyCallback,
  options?: UseHotkeyOptions
): void => {
  useTanstackHotkey(
    hotkey,
    (event, context) => {
      const shortcut = context?.hotkey ?? String(hotkey);
      trackKeyboardShortcutPressed({ shortcut });
      return callback(event, context);
    },
    options
  );
};
